<template>
  <div id="index">
    <loading-overlay v-if="loading"></loading-overlay>
    <el-row class="tac">
      <el-col :span="24" class="Box">
        <div style="
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid rgba(238, 239, 242, 1);
          ">
          <el-menu :default-active="$route.path | getRouterActive" class="el-menu-demo" text-color="#333"
            @select="SelectMenu" :router="true">
            <el-menu-item class="el-menu-item" v-for="(item, index) in targetRoutes" :key="index" :index="item.path">{{
      item.meta.title }}</el-menu-item>
          </el-menu>
          <div class="enterbutton" @click="enter()" v-if="legalCounselApply">
            申请顾问
          </div>
        </div>
        <!-- <Table :list="list" :loading="loading"/> -->
        <router-view ref="child"></router-view>
      </el-col>
    </el-row>
    <el-dialog title="顾问申请" center="" :visible.sync="dialogVisible" width="50%" :before-close="handleClose"
      @closed="closeForm('enterForm')">
      <el-form ref="enterForm" :model="enterForm" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位性质" label-width="150px" prop="unitType">
              <el-select v-model="enterForm.unitType" class="all-select" clearable collapse-tags placeholder="请选择"
                @change="ChangeUnitType">
                <el-option v-for="item in unitTypes" :key="item.typeid" :label="item.typename" :value="item.typeid" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="单位企业" label-width="150px" prop="name">
              <el-input v-model="enterForm.name"  placeholder="请输入内容" clearable v-if="enterForm.unitType=='个人'"
                @change="GetCounselConflict" />
                <el-autocomplete v-else
                          class="input_autocomplete" 
                          v-model="enterForm.name"
                          :fetch-suggestions="querySearchName
                          "
                          placeholder="请输入内容"
                          :trigger-on-focus="false"
                          @select="handleSelectName"
                        ></el-autocomplete>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="身份证号/社会信用代码" label-width="200px" prop="idnumber">
              <el-input v-model="enterForm.idnumber" class="all-input1" placeholder="请输入内容" clearable @change="GetCounselConflict"
                />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="服务律师" label-width="150px" prop="memberId">
              <el-select v-model="enterForm.memberId" class="all-select" clearable filterable collapse-tags
                placeholder="请选择" @change="SecondApprove(enterForm.memberId, 'adviser')">
                <el-option v-for="item in members" :key="item.value" :label="item.label" :value="item.value"
                  :disabled="!item.disabled" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门审批人" label-width="150px" prop="DepApprover">
              <el-select v-model="enterForm.DepApprover" class="all-select" clearable filterable collapse-tags
                placeholder="请选择">
                <el-option v-for="item in Dep" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="二次审批人" label-width="150px" prop="secondApprover">
              <el-select v-model="enterForm.secondApprover" class="all-select" clearable filterable collapse-tags
                placeholder="请选择">
                <el-option v-for="item in secondApprovers" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用印类型" label-width="150px">
              <el-select v-model="enterForm.sealType" class="all-select" clearable collapse-tags placeholder="请选择"
                @change="sealApprove(enterForm.memberId, enterForm.sealType)">
                <el-option v-for="item in sealTypes" :key="item.sealtype" :label="item.typename"
                  :value="item.sealtype" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item
              label="用印部门审批人"
              label-width="150px"
              :rules="{ validator: validateValue, trigger:'blur',required: ischooseSeal  }"
              prop="sealApprover"
            >
              <el-select
                v-model="enterForm.sealDepApprover"
                class="all-select"
                clearable
                filterable
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sealDep"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="用印二次审批人" label-width="150px" :rules="{
      validator: validateValue,
      trigger: 'blur',
      required: ischooseSeal
    }" prop="sealApprover">
              <el-select v-model="enterForm.sealApprover" class="all-select" clearable filterable collapse-tags
                placeholder="请选择">
                <el-option v-for="item in sealApprovers" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="顾问金额" label-width="150px" prop="amount">
              <el-input v-model="enterForm.amount" class="all-input" placeholder="请输入内容" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位所属行业" label-width="150px" v-if="isperson" prop="industryID">
              <el-select v-model="enterForm.industryID" class="all-select" clearable collapse-tags placeholder="请选择">
                <el-option v-for="item in industrys" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间" label-width="150px" prop="startTime">
              <el-date-picker v-model="enterForm.startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                @change="GetCounselConflict">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" label-width="150px" prop="endTime">
              <el-date-picker v-model="enterForm.endTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                @change="GetCounselConflict">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          
        
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="file" ref="fileupload" label-width="150px">
              <el-upload class="upload_file" v-model="enterForm.file" drag
                action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=顾问申请" multiple
                :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeUpload"
                :file-list="FileList" :on-success="uploadSuccess" :on-change="onChange" :show-file-list="false"
                :on-progress="onProgress">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  最大可上传50M,jpg,jpeg,png,doc,docx,xls,xlsx类型可上传
                </div>
              </el-upload>
              <!-- 附件回显 -->
              <div v-for="(item, index) in FileList" :key="item.uid" class="file_show" style="margin-top: 10px">
                <div class="fj" v-if="!item.isShow">
                  <div style="flex: 1">
                    <img src="../../assets/file/word.svg" v-if="item.ftype == 'doc' || item.ftype == 'docx'" />
                    <img src="../../assets/file/xls.svg" v-if="item.ftype == 'xlsx' || item.ftype == 'xls'" />
                    <img src="../../assets/file/png.svg" v-if="item.ftype == 'jpg' ||
      item.ftype == 'jpeg' ||
      item.ftype == 'png'
      " />
                    <img src="../../assets/file/PDF.svg" v-if="item.ftype == 'pdf'" />
                  </div>
                  <div class="name" style="flex: 9">
                    <div class="fname">
                      {{ item.name }}
                    </div>
                    <div class="word">
                      <!-- <span @click="look(item)" class="look">预览</span> -->
                      <!-- <span class="down" @click="down(item)">下载</span> -->
                      <span @click="del(index)" class="del">删除</span>
                    </div>
                  </div>
                </div>
                <!--文件上传进度条-->
                <div class="uploadprocess" v-else>
                  <div>
                    <div class="jdtext">
                      <div class="uploadname">{{ item.name }}</div>
                      <div class="per">{{ item.curPercentage }}%</div>
                    </div>
                    <el-progress :percentage="item.curPercentage" :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="top" v-if="conflictCounsel.length > 0">
        <!-- <div class="icon"></div> -->
        <div>
          冲突顾问<span style="color: black; font-size: 14px; margin-left: 10px">(<span
              style="color: red; font-weight: 900">!</span>橙色代表冲突,灰色背景是导入数据)</span>
        </div>
      </div>
      <div class="conflictTable" v-if="conflictCounsel.length > 0">
        <el-table :data="conflictCounsel" :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }" max-height="300" class="ct_table" :row-class-name="tableRowClass">
          <el-table-column prop="name" label="单位企业">
            <template slot-scope="scope">
              <div> <span style="color: red; font-weight: 900" v-if="scope.row.isshow">!</span>
                <span :style="{
                  color: getRandomColor(scope.row.isshow)
                }">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="idnumber" label="身份证号/社会信用代码">
            <template slot-scope="scope">
              {{ scope.row.idnumber }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="开始时间" :formatter="formatTime"> </el-table-column>
          <el-table-column prop="endTime" label="结束时间" :formatter="formatTime"> </el-table-column>
          <el-table-column prop="memberId" label="服务律师">
            <template slot-scope="scope">
              {{ GetMebert(scope.row.memberId,scope.row.lawer) }}
            </template>
          </el-table-column>

        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="
      dialogVisible = false
    confirm('enterForm')
      ">确 定</el-button>
        <el-button @click="callOf('enterForm')">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
// import Table from "../../components/case/List/Table.vue";
import {
  AddCounse,
  GetMembers,
  GetIndustrys,
  GetSecondApprove,
  GetMemberSeal,
  IsConflict,
  GetAllCounsel
} from '../../api/counsel.js'
import { GetDepartmentLeaders } from '../../api/bankrupt'
export default {
  name: 'counsel',
  // components:{
  //   Table
  // },
  data() {
    var validateValue = (rule, value, callback) => {
      if (value === '' || value === null || value == undefined) {
        callback(new Error('请正确输入'))
      } else {
        callback()
      }
    }
    var isnum = (rule, value, callback) => {
      if (
        value === '' ||
        value === null ||
        value === undefined ||
        isNaN(value) ||
        value.toString().replace(/\s*/g, '') != value
      ) {
        callback(new Error('请输入金额'))
      } else {
        callback()
      }
    }

    return {
      AllLit:[],
      idnumbers:[],
      legalCounselApply: false,
      list: [],
      loading: false,
      dialogVisible: false,
      enterForm: {
        name: null,
        unitType: null,
        memberId: null,
        secondApprover: null,
        sealApprover: null,
        industryID: null,
        sealType: null,
        amount: null,
        // postTime: null,
        startTime: null,
        endTime: null,
        DepApprover: null,
        file: [],
        idnumber:null,
        // sealDepApprover:null,
      },
      FileList: [],
      value2: [],
      unitTypes: [
        { typeid: '个人', typename: '个人' },
        { typeid: '政府', typename: '政府' },
        { typeid: '部委办局', typename: '部委办局' },
        { typeid: '金融行业', typename: '金融行业' },
        { typeid: '大型国有企业', typename: '大型国有企业' },
        { typeid: '医院', typename: '医院' },
        { typeid: '教育机构', typename: '教育机构' },
        { typeid: '上市企业', typename: '上市企业' },
        { typeid: '民营企业', typename: '民营企业' },
        { typeid: '事业单位', typename: '事业单位' },
        { typeid: '外资企业', typename: '外资企业' },
        { typeid: '其他', typename: '其他' }
      ],
      sealTypes: [
        { typename: '公章', sealtype: 'official_seal' },
        { typename: '法人章', sealtype: 'corporate_seal' },
        { typename: '合同章', sealtype: 'contract_seal' },
        { typename: '公章+法人章', sealtype: 'official_corporate_seal' },
        { typename: '合同章+法人章', sealtype: 'contract_corporate_seal' }
        // { typename: '律师函专用章', sealtype: 'legal_letter_seal' }
      ],
      industrys: [],
      members: [],
      secondApprovers: [],
      sealApprovers: [],
      Dep: [],
      // sealDep:[],
      isperson: true,
      ischooseSeal: false,
      rules: {
        name: [{ validator: validateValue, trigger: 'blur', required: true }],
        idnumber: [{ validator: validateValue, trigger: 'blur', required: true }],
        DepApprover: [
          { validator: validateValue, trigger: 'blur', required: true }
        ],
        amount: [{ validator: isnum, trigger: 'blur', required: true }],
        // number: [{ validator: isnum, trigger: "blur" }],
        // sno: [{ validator: validateValue, trigger: "blur" }],
        unitType: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],

        secondApprover: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],
        sealApprover: [{ trigger: 'blur' }, { trigger: 'change' }],
        memberId: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],
        startTime: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],
        endTime: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ],
        industryID: [
          { required: true, validator: validateValue, trigger: 'blur' },
          { required: true, validator: validateValue, trigger: 'change' }
        ]
        // class: [
        //   { required: true, validator: validateValue, trigger: "blur" },
        //   { required: true, validator: validateValue, trigger: "change" },
        // ],
        // idnumber: [{ validator: validateValue, trigger: "blur" }],
      },
      loading: false,

      conflictCounsel: [],
      conflictCounselShow: false,
      conflictCounselName:null,
    }
  },
  created() {
    this.legalCounselApply =
      this.$store.state.rolesname.includes('legalCounselApply')
    this.getmember()
    this.getindustry()
    this.GetLit()
  },
  methods: {
    GetLit(){//获取所有当事人
      GetAllCounsel({}).then((res)=>{
        if(res.data.status=='success'){
          this.AllLit=res.data.data
        }else{
          this.AllLit=[]
        }
       })
    },
   //客户名称
   querySearchName(queryString, cb) {
     
     var restaurants =[]
     
     if(this.enterForm.unitType!='个人'){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
     }
     console.log(results)
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
    createFilterName(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
  handleSelectName(item){
    this.enterForm.name=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.enterForm.idnumber=unique1[0]
    }
  },
    GetMebert(row,law){
      if(row==null||row==''){
        return law
      }
      var c=this.members.find(p=>p.value==row);
      if(c){
        return c.label
      }else{
        return ''
      }
    },
    GetCounselConflict() {
      if (this.enterForm.name && this.enterForm.startTime && this.enterForm.endTime) {
        IsConflict({
          customer: this.enterForm.name,
          st: this.enterForm.startTime,
          et: this.enterForm.endTime,
          idnumber:this.enterForm.idnumber,
        }).then((res) => {
          this.loading = false
          if (res.data.status == 'success') {
            if (res.data.data == "N/A") {
              this.conflictCounsel = []
              this.conflictCounselShow = false
              this.conflictCounselName=null
            } else {
              this.conflictCounselName = JSON.parse(JSON.stringify(this.enterForm.name)) 
              console.log(this.conflictCounselName)
              if (Array.isArray(res.data.data)) {
                this.conflictCounsel = res.data.data
                this.conflictCounselShow = true
              } else {
                this.conflictCounsel = [res.data.data]
                this.conflictCounselShow = false
                // this.conflictCounselName=null
              }
            }
          } else {
            this.$message.error(res.data.message)
          }

          // this.$refs.child.search()
        })
          .catch((res) => {
            this.loading = false
            this.$message.error(res.data.message)
            return
          })
      } else {
        // console.log("触发")
        this.conflictCounsel = []
        this.conflictCounselShow = false
        this.conflictCounselName=null
      }

    },
    getRandomColor(show) {
      if (show) return '#e86e30'
      else return 'blue'
    },
    //日期格式转换
    formatTime(row, column) {
      if (row[column.property] == null) {
        return null
      }
      const date = new Date(row[column.property])
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year + '-' + month + '-' + day
        // day +
        // ' ' +
        // hours +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
    },
    handleRemove(file, fileList) {
      //删除附件
      this.FileList.forEach((value, index, array) => {
        //删除上传失败的文件
        // console.log(file.uid)
        if (value.uid == file.uid) {
          array.splice(index, 1)
        }
      })
    },
    handlePreview(file) {
      // console.log(file);
    },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    onProgress(event, file) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      this.FileList.forEach((value) => {
        //uid要改成guid,isshow变成false
        if (value.uid == file.uid) {
          value.curPercentage = num
        }
      })
    },

    onChange(file) {
      if (file.status == 'fail') {
        this.FileList.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
        return this.$message.error(file.name + '上传失败')
      }
    },
    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    beforeUpload(file, filelist) {
      var type = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      this.FileList.push({
        uid: file.uid,
        name: filename,
        ftype: type,
        isShow: true,
        curPercentage: 0
      }) //添加上传的文件

      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(type) >=
        0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList) {
      //上传成功
      // console.log(file)
      if (res.status == '0') {
        // this.$refs.fileupload.clearValidate()
        this.FileList.forEach((value) => {
          //uid要改成guid,isshow变成false
          if (value.uid == file.uid) {
            value.isShow = false
            value.uid = file.response.data.substring(
              file.response.data.lastIndexOf('=') + 1
            )
          }
        })
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },
    del(index) {
      this.FileList.splice(index, 1)
    },
    validateValue(rule, value, callback) {
      if (
        this.enterForm.sealType == undefined ||
        this.enterForm.sealType == '' ||
        this.enterForm.sealType == null
      ) {
        callback()
      } else if (value === '' || value === null || value == undefined) {
        callback(new Error('请正确输入'))
      } else {
        callback()
      }
    },
    //获取部门审批人
    GetDepartmentLeaders(id) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          this.Dep = res.data.data
          // if (this.enterForm.sealType != undefined || this.enterForm.sealType != "" || this.enterForm.sealType != null) {
          //   this.sealDep=this.Dep;
          // }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    enter() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    callOf() {
      this.dialogVisible = false
    },
    //申请
    confirm(formName) {
      this.enterForm.file = this.FileList.map((v) => {
        return v.uid
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          AddCounse({
            Name: this.enterForm.name,
            UnitType: this.enterForm.unitType,
            MemberId: this.enterForm.memberId,
            SecondApprover: this.enterForm.secondApprover,
            SealApprover: this.enterForm.sealApprover,
            IndustryID: this.enterForm.industryID,
            SealType: this.enterForm.sealType,
            Amount: this.enterForm.amount,
            // PostTime: this.enterForm.postTime,
            StartTime: this.enterForm.startTime,
            EndTime: this.enterForm.endTime,
            FileArr: this.enterForm.file,
            DepApprover: this.enterForm.DepApprover,
            idnumber:this.enterForm.idnumber,
            // sealDepApprover:this.enterForm.sealDepApprover,
          })
            .then((res) => {
              this.loading = false
              if (res.data.status == 'success') {
                this.$message.success('新增顾问成功')
              } else {
                this.$message.error(res.data.message)
              }

              // this.$refs.child.search()
            })
            .catch((res) => {
              this.loading = false
              this.$message.error(res.data.message)
              return
            })
        } else {
          this.$message.warning('请填入必填项')
          this.dialogVisible = true
          return false
        }
      })
    },
    //单位性质改变事件
    ChangeUnitType() {
      if (this.enterForm.unitType == '个人') {
        this.isperson = false
        this.enterForm.industryID = null
      } else {
        this.isperson = true
      }
    },
    // 关闭dialog时清空表单
    closeForm(formName) {
      this.$refs.child.search()
      this.enterForm.sealType = null
      this.enterForm.idnumber=null
      this.ischooseSeal = false
      this.secondApprovers = []
      this.sealApprovers = []
      this.FileList = []
      this.conflictCounsel = []
      this.conflictCounselShow = false
      this.conflictCounselName=null
      this.$refs[formName].resetFields()
    },

    SelectMenu(item) {
      let that = this
      that.$router.push({
        path: `${item}`
      })
    },

    // 获取律师
    getmember() {
      GetMembers()
        .then((res) => {
          if (res.data.status == 'success') {
            this.members = res.data.data.filter((item) => item.status == 0 || item.status == 6)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取律师出错')
        })
    },
    // 获取行业
    getindustry() {
      GetIndustrys()
        .then((res) => {
          if (res.data.status == 'success') {
            this.industrys = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取行业出错')
        })
    },
    // 获取二次审批人
    SecondApprove(memberid, type) {
      this.enterForm.secondApprover = null
      this.enterForm.DepApprover = null
      if (type == undefined || type == '' || type == null) {
        return
      }
      if (memberid == undefined || memberid == '' || memberid == null) {
        return
      }
      this.GetDepartmentLeaders(memberid)
      GetSecondApprove({
        id: memberid,
        type: type
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.secondApprovers = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取二次审批人出错')
        })

      this.sealApprove(this.enterForm.memberId, this.enterForm.sealType)
    },
    // 获取用章二次审批人
    sealApprove(memberid, type) {
      this.enterForm.sealApprover = null
      // this.enterForm.sealDepApprover = null;
      if (type == undefined || type == '' || type == null) {
        this.sealApprovers = []
        this.ischooseSeal = false
        return
      } else {
        this.ischooseSeal = true
      }
      if (memberid == undefined || memberid == '' || memberid == null) {
        return
      }
      // this.sealDep=this.Dep;
      GetMemberSeal({
        id: memberid,
        type: type
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.sealApprovers = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('获取用章二次审批人出错')
        })
    },
    tableRowClass({ row, rowIndex }){
      console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }
  },
  filters: {
    getRouterActive(path) {
      let str = path.split('/')
      return str[3]
    }
  },
  computed: {
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/counsel' //遍历每一个数组，过滤出返回值委true的值
      )
      return target[0].children
    }
  }
}
</script>
<style lang="less" scoped>
#index {
  .tac {
    .el-menu {
      display: flex;
      // height: 55px;
      text-align: center;
      border-right: 0px;

      // margin-bottom: 5vh;
      // .el-menu-item{
      //   width:20vh;
      // }
      .el-menu-item {
        margin: 0 20px;
        height: 100%;
        display: flex;
        align-items: center;
        min-width: 30px;
        width: 10vh;
        justify-content: center;

        &:hover {
          background-color: #fff;
          color: #409eff !important;
          border-bottom: 2px solid #409eff;
        }
      }

      .el-menu-item.is-active {
        background-color: #fff !important;
        border-bottom: 2px solid #409eff;
      }
    }

    .enterbutton {
      width: 99px;
      height: 40px;
      margin: 10px;
      color: #fff;
      background-color: #2bc887;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
  }

  .Box {
    // padding: 20px 30px;
    box-sizing: border-box;
    background: #fff;
    // background: #409eff;
    height: 100%;
    border-radius: 0%;
  }

  .all-input {
    width: 80%;
    margin-bottom: 1rem;
  }
  .all-input1 {
    width: 96%;
    margin-bottom: 1rem;
  }
  .all-select {
    width: 80%;
    margin-bottom: 1rem;
  }

  .all-date {
    margin-bottom: 1rem;
  }

  .upload-demo {
    margin-bottom: 1rem;
  }

  .el-menu-item {
    font-size: 16px;
  }
}

// 附件回显
#index .upload_file {
  width: 360px;
}

#index .file_show {
  width: 360px;
}

#index .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#index img {
  width: 100%;
  height: 100%;
}

#index .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#index .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#index .word {
  line-height: 24px;
  cursor: default;
}

#index /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#index .look {
  color: #fe964a;
  margin-right: 10px;
}

#index .down {
  color: #2bc887;
  margin-right: 10px;
}

#index .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#index .uploadprocess {
  width: 360px;
}

#index .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#index .jdtext {
  width: 360px;
  display: flex;
}

#index .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}
.conflictTable {
    width: 100%;
  }
  .top {
    width: 100%;
    display: flex;
    color: #3077e6;
    align-items: center;
    font-size: 1.1875rem;
    font-weight: 400;
    padding-left: 3.625rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  /deep/.beig-row{
      background: #e6e5e4 !important;
  }
</style>
